module.exports = __webpack_public_path__ + "static/media/103.44bb6847.png";